<template>
    <div class="g_panel">
        <div v-if="header!=null" class="header">{{ header }}</div>
        <slot></slot>
    </div>
</template>
<script>
export default{
    name: 'Panel',
    props: {
        header:{
            default: null
        }
    }
}
</script>
<style lang="scss" >
    .g_panel {
        // border: 1px solid red;
        box-shadow: 0 8px 35px 0 rgba(0, 0, 0, 0.16);
        padding: 0.8rem;
        background-color: white;
        border-radius: 3px;
        .header{
            font-weight: 800;
            font-size: 1.7rem
        }
    }
</style>